import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getSurveyList = () => {
  const dtMoodSession = getDtMoodSession()
  const userId = dtMoodSession ? dtMoodSession.userId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/survey-results/list?userId=${userId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getSurveyDetail = (surveyId) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/survey-questions/survey/${surveyId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sendSurveyAnswer = (data) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .post('/survey-answers', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getSurveyList, getSurveyDetail, sendSurveyAnswer }
